(function() {
  // 隐藏原来的按钮
  function hideOriginalButton() {
    const originalBtn = document.querySelector('.tpo-buy-it-now-btn');
    if (originalBtn) {
      originalBtn.style.display = 'none';
    }
  }

  // 等待页面加载完成
  function addNewButton() {
    // 找到价格区域或者 product-form__buttons 区域
    const productForm = document.querySelector('.product-form__buttons');
    if (!productForm) return;

    // 检查是否已经添加过，避免重复添加
    if (document.querySelector('.my-custom-button')) return;

    // 创建新按钮
    const newButton = document.createElement('button');
    newButton.className = 'my-custom-button';
    newButton.textContent = '지금 구매';  // 按钮文字

    // 设置按钮样式
    newButton.style.cssText = `
      width: 100%;
      padding: 12px 20px;
      margin-top: 12px;
      background-color: #ff2f5b;
      color: white;
      font-size: 18px;
      font-weight: bold;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
    `;

    // 鼠标悬停效果
    newButton.onmouseover = function() {
      this.style.backgroundColor = '#e0254a';
    };
    newButton.onmouseout = function() {
      this.style.backgroundColor = '#ff2f5b';
    };

    // 点击事件：触发隐藏的 .tpo-buy-it-now-btn
    newButton.onclick = function() {
      const targetBtn = document.querySelector('.tpo-buy-it-now-btn');
      if (targetBtn) {
        targetBtn.click();
      } else {
        console.log('.tpo-buy-it-now-btn 未找到');
      }
    };

    // 添加到页面（在现有按钮后面）
    productForm.appendChild(newButton);
  }

  // 页面加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      hideOriginalButton();
      addNewButton();
    });
  } else {
    hideOriginalButton();
    addNewButton();
  }

  // 如果页面是 Shopify 动态加载的，用 MutationObserver 监听
  const observer = new MutationObserver(function() {
    hideOriginalButton();
    addNewButton();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();